// JS
import React, { useState } from 'react';
import {
  //devOrProd,
  getInternationalPriceNuqlium,
  /*brandUrl,*/ ppHeadingOverridesOpen,
  swapImg,
} from '../shared/utils';

// COMP
import DiscountPrice from '../DiscountPrice';
import PhotoGalleryPopup from '../PhotoGalleryPopup';
import Slider from '../Slider';
//import GetBrandLogo from '../shared/GetBrandLogo';

// COMPONENT
const PhotoGalleryMobile = ({
  data,
  isMobile,
  userSession,
  text,
  blackFriday,
  isSale,
  freeDelBadge,
  restockBadge,
  bfExcludedCategories,
}) => {
  const [showHideGalleryPopup, setShowHideGalleryPopup] = useState(false);
  return (
    <>
      {showHideGalleryPopup && (
        <PhotoGalleryPopup
          data={data}
          isMobile={isMobile}
          showHideGalleryPopup={showHideGalleryPopup}
          setShowHideGalleryPopup={setShowHideGalleryPopup}
        />
      )}
      {data && (
        <div className="photo-gallery-mobile">
          <div className="flex flex-col gap-2 absolute z-10 top-5 left-5 empty:hidden">
            {blackFriday &&
              data.product.categorylist.includes('WEB_BLK_FRI') &&
              !bfExcludedCategories.some((el) =>
                data.product.categorylist.includes(el)
              ) && <div className="desktop-image-BF-badge">25% Off</div>}
            {/*data.product.categorylist.includes('WEB_NIKE30') && (
              <div className="desktop-image-BF-badge">30% Off</div>
            )*/}
            {/*data.product.categorylist.includes('WEB_CP30') && (
              <div className="desktop-image-BF-badge">30% Off</div>
            )*/}
            {restockBadge &&
              data.product.categorylist.includes('WEB_FREEDELEXCL') && (
                <div className="desktop-image-BF-badge re-stock">Re-stock</div>
              )}
            {freeDelBadge &&
              getInternationalPriceNuqlium() === 'retail_gbp' &&
              !data.product.categorylist.includes('WEB_LAUNCHES') &&
              data.product.option.priceasnumber >= 90 &&
              data.product.option.priceasnumber ===
                data.product.option.promotionpriceasnumber && (
                <div className="desktop-image-BF-badge free-delivery">
                  Free Standard Delivery
                </div>
              )}
            {isSale ? (
              <DiscountPrice isSale={isSale} data={data} text={'Off'} />
            ) : (
              <DiscountPrice data={data} text={text} />
            )}
          </div>
          {/* Un-comment to show brand logo on mobile
            <div className="photo-gallery-mobile-discount-logo">
              {GetBrandLogo(data.product.attributes.brand[0]) && (
                <div className="brand-logo">
                  <a
                    href={`/brands/${brandUrl(
                      data.product.attributes.brand[0]
                    )}/${userSession}`}
                    style={{ display: 'block' }}
                    title={`View ${data.product.attributes.brand[0]} Brand Page`}
                  >
                    {data.product.attributes.brand && (
                      <img
                        src={GetBrandLogo(data.product.attributes.brand[0])}
                        alt={data.product.attributes.brand[0]}
                      />
                    )}
                  </a>
                </div>
              )}
            </div>
          */}

          <Slider
            responsive={{
              sm: {
                show: 1,
                spaceBetween: 0,
              },
            }}
            infinite={true}
            usePagination={true}
            paginationOptionsMobGallery="mx-2 w-3 h-3 after:h-3 after:w-3"
            paginationAltBgColor={true}
            paginationOptions={{
              rounded: true,
              noContain: true,
              classes: {
                wrapper: 'absolute z-20 w-full text-center ',
              },
            }}
            showGalleryPopup={(e) => {
              e.preventDefault();
              setShowHideGalleryPopup(true);
              window.scrollLock();
              ppHeadingOverridesOpen();
            }}
          >
            {data.product.attributes.alternatives.map((slide, i) => (
              <div className="swiper-zoom-container" key={`cell[${i}]`}>
                <img
                  src={`${swapImg(slide, 'medium', 'large')}`}
                  alt={`${data.product.name} [${i}]`}
                  fetchpriority={i === 0 ? 'high' : 'auto'}
                />
              </div>
            ))}
          </Slider>
        </div>
      )}
    </>
  );
};

export default PhotoGalleryMobile;
